<template>
  <div class="!pt-3">
    <el-row :gutter="20">
      <el-col :span="12">
        <div class="form-group">
          <el-form-item>
            <label
              class="field-title-label !text-black-600 !text-xs 2xl:!text-sm !font-normal block !mb-1"
            >
              Heading / Title
              <span class="text-red-500">*</span>
            </label>
            <el-input
              type="text"
              v-model="field.label"
              placeholder="Enter content or block title"
              class="!my-1 w-full"
            ></el-input>
          </el-form-item>
        </div>
      </el-col>

      <el-col :span="12">
        <div class="form-group">
          <el-form-item>
            <label
              class="field-title-label !text-black-600 !text-xs 2xl:!text-sm !font-normal block !mb-1"
            >
              Heading Type
              <span class="text-red-500">*</span>
            </label>
            <br />
            <el-select
              v-model="field.heading_type"
              value-key="field.heading_type"
              placeholder="Select Heading Type"
              class="!my-1 w-full"
            >
              <el-option
                v-for="item in options"
                :key="item"
                :label="item"
                :value="item"
              ></el-option>
            </el-select>
          </el-form-item>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
  export default {
    name: 'templates-formComponents-Content',
    props: ['field'],
    data() {
      return {
        options: ['H1', 'H2', 'H3', 'H4', 'H5', 'H6'],
        heading_type: '',
      };
    },
    mounted() {},
  };
</script>

<style lang="scss">
  .mgtop {
    margin-top: 10px;
  }

  .red-asterisk {
    color: red;
  }
</style>
